module.exports = __webpack_public_path__ + "img/costEffective.16c6571c.jpg";